<script setup>
import { useAttrs, computed } from 'vue';

const attrs = useAttrs();

const isDarkMode = computed(() => {
  return document.body.classList.contains('dark');
});
</script>

<template>
  <!-- Custom Escaleshop Logo - sempre usar nossa logo -->
  <svg
    v-bind="attrs"
    viewBox="0 0 36 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.26 4.68005L30.82 14.0901H0L5.44 4.68005H36.26Z"
      :fill="isDarkMode ? '#E2F44D' : '#101518'"
    />
    <path
      d="M36.26 18.79L30.82 28.21H0L5.44 18.79H36.26Z"
      :fill="isDarkMode ? '#E2F44D' : '#101518'"
    />
    <path
      d="M36.26 32.91L30.82 42.32H0L5.44 32.91H36.26Z"
      :fill="isDarkMode ? '#E2F44D' : '#101518'"
    />
  </svg>
</template>
